import classNames from "classnames";
import gridTableStyles from "@general/Tables/GridTable/GridTableBase.module.scss";
import { FC } from "react";
import { TransactionListItemDto } from "../../../common/types/transaction";
import { formatDateForTransaction } from "../../../helpers/date";
import { TransactionDescriptionContent } from "../transactionContent/TransactionDescriptionContent";
import { TransactionAccountColumnContent } from "../../transactions/ListItem/TransactionAccountColumnContent";
import { EntityIcon } from "../../entity/EntityIcon";
import { TransactionAmount } from "../../transactions/TransactionAmount";
import styles from "./TransactionsPreviewTable.module.scss";

interface Props {
    total: number;
    transactions: TransactionListItemDto[];
    onViewAll(): void;
}

export const TransactionsPreviewTable: FC<Props> = ({
    total,
    transactions,
    onViewAll,
}) => (
    <div className={classNames(gridTableStyles.gridTable, styles.table)}>
        {transactions.map((transaction) => (
            <div
                className={classNames(gridTableStyles.row, styles.row)}
                key={transaction.id}
            >
                <div>{formatDateForTransaction(transaction.date)}</div>

                <TransactionDescriptionContent transaction={transaction} />

                <TransactionAccountColumnContent
                    transaction={transaction}
                    size="xs"
                />

                <TransactionAmount
                    className={styles.amount}
                    transaction={transaction}
                />

                <div>
                    <EntityIcon entity={transaction.entity} size="xs" />
                </div>
            </div>
        ))}

        <footer className={styles.footer} onClick={onViewAll}>
            View all ({total})
        </footer>
    </div>
);
